import React from 'react';
 
const About = () => {
    return (
        <div id="about" className="pre-about-container">
            
            <div className="about-container">

                <div className="about">

                    <h1>About Me</h1>
                    <div className="about-wrapper">
                        <p>
                            I'm <span style={{color: "#5e5e5e"}}>Koketjo Sethobja</span>. A Web Developer and Software Developer
                            based in South Africa, Gauteng🌍. I'm a Bachelor of Science graduate🎓
                            in Information Technology💻 from North-West University. I build websites 
                            and other cool tools😎 for other people to use. I love to create cool things.
                            The web is my playground. I love tinkering🛠 with it and making it better.
                            I am curious, hard-working, and passionate about building high quality products.
                            <br /><br />
                            I build websites in React JS, and Node Js (Express). I find React Js and other 
                            as an easy framework to learn and it's fast🌠, it enables you to re-use a code without 
                            writing it again💯. I also build softwares using Java with Springboot. Java is a broad backend
                            language and with Springboot, it can do wonders🧠.
                        </p>
                    </div>

                </div>

            </div>

        </div>
    )
}
 
export default About;